export const AssetDetailTabEnum = {
  OVERVIEW: "ASSET_DETAIL_TAB_OVERVIEW",
  SUBDOMAINS: "ASSET_DETAIL_TAB_SUBDOMAINS",
  PORTS: "ASSET_DETAIL_TAB_PORTS",
  VULNERABILITIES: "ASSET_DETAIL_TAB_VULNERABILITIES",
  CERTIFICATES: "ASSET_DETAIL_TAB_CERTIFICATES",
};
